import { PathsType } from '../types/types'

const Paths: PathsType = {
	cs: {
		'/salons': '/salony/',
		'/salons/all': '/salony/vsechny/',
		'/salons/all/:categorySlug': '/salony/vsechny/:categorySlug/',
		'/salons/all/:categorySlug/:citySlug': '/salony/vsechny/:categorySlug/:citySlug/',
		'/salons/:salonSlug': '/salony/:salonSlug/',
		'/salons/my-reservations': '/salony/moje-rezervace/',
		'/salons/my-reservations/:reservationID': '/salony/moje-rezervace/:reservationID/',
		'/salons/passes': '/salony/permanentky/',
		'/salons/passes/:passID': '/salony/permanentky/:passID/',
		'/salons/auth-complete': '/salony/auth-complete/'
	},
	sk: {
		'/salons': '/salony/',
		'/salons/all': '/salony/vsetky/',
		'/salons/all/:categorySlug': '/salony/vsetky/:categorySlug/',
		'/salons/:salonSlug': '/salony/:salonSlug/',
		'/salons/all/:categorySlug/:citySlug': '/salony/vsetky/:categorySlug/:citySlug/',
		'/salons/my-reservations': '/salony/moje-rezervacie/',
		'/salons/my-reservations/:reservationID': '/salony/moje-rezervacie/:reservationID/',
		'/salons/passes': '/salony/permanentky/',
		'/salons/passes/:passID': '/salony/permanentky/:passID/',
		'/salons/auth-complete': '/salony/auth-complete/'
	},
	bg: {
		'/salons': '/saloni/',
		'/salons/all': '/saloni/vsichki/',
		'/salons/all/:categorySlug': '/saloni/vsichki/:categorySlug/',
		'/salons/:salonSlug': '/saloni/:salonSlug/',
		'/salons/all/:categorySlug/:citySlug': '/saloni/vsichki/:categorySlug/:citySlug/',
		'/salons/my-reservations': '/saloni/moite-rezervi/',
		'/salons/my-reservations/:reservationID': '/saloni/moite-rezervi/:reservationID/',
		'/salons/passes': '/saloni/abonamenti/',
		'/salons/passes/:passID': '/saloni/abonamenti/:passID/',
		'/salons/auth-complete': '/saloni/auth-complete/'
	},
	hu: {
		'/salons': '/szalonok/',
		'/salons/all': '/szalonok/osszes/',
		'/salons/all/:categorySlug': '/szalonok/osszes/:categorySlug/',
		'/salons/all/:categorySlug/:citySlug': '/szalonok/osszes/:categorySlug/:citySlug/',
		'/salons/:salonSlug': '/szalonok/:salonSlug/',
		'/salons/my-reservations': '/szalonok/fenntartasaim/',
		'/salons/my-reservations/:reservationID': '/szalonok/fenntartasaim/:reservationID/',
		'/salons/passes': '/szalonok/berletek/',
		'/salons/passes/:passID': '/szalonok/berletek/:passID/',
		'/salons/auth-complete': '/szalonok/auth-complete/'
	},
	ro: {
		'/salons': '/saloane/',
		'/salons/all': '/saloane/toate/',
		'/salons/all/:categorySlug': '/saloane/toate/:categorySlug/',
		'/salons/all/:categorySlug/:citySlug': '/saloane/toate/:categorySlug/:citySlug/',
		'/salons/:salonSlug': '/saloane/:salonSlug/',
		'/salons/my-reservations': '/saloane/rezervele-mele/',
		'/salons/my-reservations/:reservationID': '/saloane/rezervele-mele/:reservationID/',
		'/salons/passes': '/saloane/abonamente/',
		'/salons/passes/:passID': '/saloane/abonamente/:passID/',
		'/salons/auth-complete': '/saloane/auth-complete/'
	},
	hr: {
		'/salons': '/saloni/',
		'/salons/all': '/saloni/sve/',
		'/salons/all/:categorySlug': '/saloni/sve/:categorySlug/',
		'/salons/all/:categorySlug/:citySlug': '/saloni/sve/:categorySlug/:citySlug/',
		'/salons/:salonSlug': '/saloni/:salonSlug/',
		'/salons/my-reservations': '/saloni/moje-rezervacije/',
		'/salons/my-reservations/:reservationID': '/saloni/moje-rezervacije/:reservationID/',
		'/salons/passes': '/saloni/abonmani/',
		'/salons/passes/:passID': '/saloni/abonmani/:passID/',
		'/salons/auth-complete': '/saloni/auth-complete/'
	},
	'de-AT': {
		'/salons': '/salons/',
		'/salons/all': '/salons/alle/',
		'/salons/all/:categorySlug': '/salons/alle/:categorySlug/',
		'/salons/all/:categorySlug/:citySlug': '/salons/alle/:categorySlug/:citySlug/',
		'/salons/:salonSlug': '/salons/:salonSlug/',
		'/salons/my-reservations': '/salons/meine-buchungen/',
		'/salons/my-reservations/:reservationID': '/salons/meine-buchungen/:reservationID/',
		'/salons/passes': '/salons/mehrfachkarten/',
		'/salons/passes/:passID': '/salons/mehrfachkarten/:passID/',
		'/salons/auth-complete': '/salons/auth-complete/'
	}
}

export default Paths
